import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';
export function savedConfigurationMigrationBuilder({parsedStatusObj}) {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Saved Configuration Migration Error:
        {parsedStatusObj.configurationName
          ? parsedStatusObj.configurationName
          : 'unknown configuration'}
        .
      </Body3>
    </td>
  );
}
